import { render } from "./TipsScreen.vue?vue&type=template&id=1169d43b&scoped=true"
import script from "./TipsScreen.vue?vue&type=script&lang=js"
export * from "./TipsScreen.vue?vue&type=script&lang=js"

import "./TipsScreen.vue?vue&type=style&index=0&id=1169d43b&scoped=true&lang=css"

import exportComponent from "/Users/benjamin/Documents/GitHub/beatmania-app-structure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1169d43b"]])

export default __exports__